import { Breakpoint, styled, useMediaQuery, useTheme } from '@mui/system'
import { Link } from 'gatsby'
import React from 'react'
import WcidFull from '../images/icons/wcid_full'
import WcidLogo from '../images/icons/wcid_logo'
import { VBox } from '../elements/basic-elements'
import { Typography } from '@mui/material'

const REGULAR_LOGO_SIZE = 64
const SMALL_LOGO_SIZE = 44

const LogoLink = ({
  logoOnlyBreakpoint = 'lg',
  includeINILink
}: {
  logoOnlyBreakpoint?: Breakpoint
  includeINILink?: boolean
}) => {
  const theme = useTheme()
  const useLogoOnly = useMediaQuery(theme.breakpoints.down(logoOnlyBreakpoint))
  const useSmallLogo = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <VBox gap={0.5} justifyContent="flex-start" flex={1}>
      <StyledLink
        to="/"
        activeClassName="active"
        sx={{ width: useLogoOnly ? 'auto' : 165 }}
        aria-label="Navigate to Home Page"
      >
        {useLogoOnly ? (
          <WcidLogo size={useSmallLogo ? SMALL_LOGO_SIZE : REGULAR_LOGO_SIZE} />
        ) : (
          <WcidFull />
        )}
      </StyledLink>
      {includeINILink && !useLogoOnly && (
        <Typography
          ml={0.5}
          fontWeight={700}
          color="textPrimary"
          textTransform="uppercase"
          fontSize={10}
          component="a"
          whiteSpace="nowrap"
          href="https://www.importantnotimportant.com/"
          target="_blank"
          sx={{ textDecoration: 'none' }}
        >
          <Typography component="span" fontWeight={400} fontSize={10}>
            By
          </Typography>{' '}
          Important, Not Important
        </Typography>
      )}
    </VBox>
  )
}

export const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  position: relative;
`

export default LogoLink
